"use client";

import { NewsletterSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedNewsletterSection from "../Components/GeneratedNewsletterSection";

const Newsletter: FC<NewsletterSectionProps> = (props) => {
  return <GeneratedNewsletterSection {...props} />;
};

export default Newsletter;
